import PopupProfile from './container';

export default PopupProfile;
